import React from 'react';
import { Icon } from 'venn-ui-kit';

interface AddInvestmentCommonHeaderProps {
  title: string | React.ReactNode;
  onClose: () => void;
}

export const AddInvestmentCommonHeader = ({ title, onClose }: AddInvestmentCommonHeaderProps) => {
  return (
    <div className="h-10 py-2 px-4 flex items-center justify-between bg-venn-grey-10 m-0 border-0 border-solid border-b border-venn-grey-30 gap-2 flex-grow-0">
      <span className="min-w-0 flex-1 truncate text-[14px] text-venn-grey-80 uppercase">{title}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close modal"
        className="w-6 h-6 shrink-0 flex items-center justify-center cursor-pointer rounded-[4px] border border-solid border-venn-grey-30 bg-white text-[12px] hover:text-gray-600 "
      >
        <Icon type="times" className="text-venn-dark-blue" />
      </button>
    </div>
  );
};
